export const W8_MODALS_LOADING_STATES = {
    FETCH_W8_FORMS_LOADING: "FETCH_W8_FORMS_LOADING",
    FETCH_W8_FORMS_READY: "FETCH_W8_FORMS_READY",
    REQUEST_BULK_W8_LOADING: "REQUEST_BULK_W8_LOADING",
    REQUEST_BULK_W8_READY: "REQUEST_BULK_W8_READY",
    DISPLAY_PLANS_VIEW_LOADING: "DISPLAY_PLANS_VIEW_LOADING",
    DISPLAY_PLANS_VIEW_READY: "DISPLAY_PLANS_VIEW_READY",
    GET_W8_REQUEST_COUNT_LOADING: "GET_W8_REQUEST_COUNT_LOADING",
    GET_W8_REQUEST_COUNT_READY: "GET_W8_REQUEST_COUNT_READY",
    GET_W8_FEES_LOADING: "GET_W8_FEES_LOADING",
    GET_W8_FEES_READY: "GET_W8_FEES_READY",
}

export const W8_MODALS_MESSAGE_MAP = {
    [W8_MODALS_LOADING_STATES.FETCH_W8_FORMS_LOADING]: "loading forms",
}

export const SELECT_W8_FORM_DROPDOWN_FIELD_NAME = "selectW8Form"